export default {
    workFlow: {
        run: '运行',
        timeRun: '定时运行',
        nodeDesc: '请输入节点描述',
        config: '配置',
        historyRecord: '历史记录',
        deleteNode: '删除后不可恢复，确定要删除吗?',
        deleteNodeBtn: '确定删除',
        nodeContent: '请输入节点内容',
        pleaseInput: '请输入',
        pleaseUpload: '请上传',
        input: '输入',
        select: '选择',
        please: '请',
        pleaseInputNodeName: '请输入节点名称',
        insertVariable: '插入变量',
        noNode: '暂无节点',
        copy: '复制',
        delete: '删除',
        deleteNodeTitle: '删除节点',
        addSubParameter: '新增子参数',
        array: '数组',
        object: '对象',
        professionalFunction: '专业版功能，详见',
        professionalFunctionDesc: '专业版增值功能，详见',
        upgradeToVersion: '升级到 {version} 版本',
        versionDescription: '版本说明',
        nodeInput: '节点输入：',
        nodeInputLabel: '节点输入',
        nodeInputDesc: '节点输入默认为上个节点的输出，可添加其它节点变量或自定义文本',
        lastNode: '上一个节点',
        unknownNodeOutput: '未知的节点的输出',
        branchNode: '分支节点',
        basicNode: '基础节点',
        individualityNode: '个性节点',
        imageInputDesc: '当开始节点的图像输入设置中选择“需同时输入图片和文字”时，该输入即为图像识别的用户提问，默认为开始节点的文本输入',
        createWorkFlow: '创建工作流',
        copyWorkFlowTemplate: '去模板中心复制',
        workFlowName: '工作流名称',
        pleaseInputWorkFlowName: '请输入工作流名称',
        workFlowDesc: '工作流描述',
        pleaseInputWorkFlowDesc: '请输入工作流描述',
        workFlowAvatar: '工作流头像',
        aiGenerate: 'AI生成',
        workFlowCategory: '工作流分类',
        pleaseSelectCategory: '请选择分类',
        pleaseVisitPC: '为保证显示效果，请在PC端访问',
        imageUploadSupport: '图片上传只支持 jpeg,png 格式',
        imageSizeLessThan5MB: '图片大小需小于 5MB!',
        copyWorkFlowConfirm: '将自动创建一个相同的工作流，确认复制吗？',
        copySuccess: '复制成功',
        workflowCopy: '工作流复制',
        deleteWorkFlowConfirm: '是否确认删除当前工作流?',
        deleteWorkFlow: '删除工作流',
        deleteSuccess: '删除成功',
        pleaseUploadWorkFlowAvatar: '请上传工作流头像',
        pleaseSelectCategoryWarn: '请选择分类!',
        startDialog: '开始对话',
        AppNode: {
            appTip: '应用：',
            memoryTip: '记忆：',
            memoryTipDesc: '温度越高回复越具有创意和不确定性，温度越低则回复更严谨',
            memoryTipDesc1: '开启后该节点将使用工作流的记忆，关闭则使用该应用本身的记忆（在应用配置中设置）。',
            memoryTipDesc2: '工作流每轮记忆指每次运行的 开始节点 输入和 结束节点输出（不包含中间过程内容）。',
            memoryTipDesc3: '工作流的记忆内容可能经过了多个与本节点无关的节点加工后得出，请根据实际需求选择是否开启。',
            pleaseSelectMemoryTurn: '请选择记忆轮次',
            memoryTurn: '轮次',
        },
        ChannelNode:{
            selectChannel: '选择渠道：',
            supportChannel: '支持微信、企业微信托管渠道',
            hostingChannel: '托管接入渠道',
            WebhookSend: 'Webhook推送',
            clientTip: '客户端：',
            sendPerson: '发送人：',
            sendType: '发送类型：',
            singleChat: '单聊',
            groupChat: '群聊',
            receiver: '接收者',
            loading: '正在加载',
            edit: '编辑',
            more: '查看更多',
            pleaseFill: '请填写',
            configDesc: '配置说明',
            pleaseInputName: '请输入名称搜索',
            search: '搜索',
            headImg: '头像',
            name: '名称',
            dialogApp: '对话应用',
            dingTalk: '钉钉群机器人',
            feiShu: '飞书群机器人',
            weWork: '企微群机器人',
            dingTalkTip: '请在钉钉群中添加自定义机器人，并获取Webhook地址：',
            feiShuTip: '请在飞书群中添加自定义机器人，并获取Webhook地址：',
            weWorkTip: '请在企微内部群中添加群机器人，并获取Webhook地址：',
            dingTalkTip1: '钉钉群机器人安全设置选择“加签”，并获取密钥：',
            feiShuTip1: '飞书群机器人安全设置选择“签名校验”，并获取密钥：',
            pleaseSelectSender: '请先选择发送人',
            pleaseSelectClient: '请先选择客户端',
            pleaseSelectSendType: '请先选择发送类型',
        },
        CodeNode: {
            variableInput: '变量输入',
            pleaseInputParameter: '请输入参数',
            addParameter: '新增参数',
            codeBlock: '代码块',
            variableOutput: '变量输出',
            pleaseInputName: '请输入名称',
            editCode: '编辑代码',
            codeLogic: '以下为代码逻辑，注意缩进',
        },
        DatabaseNode: {
            databaseTitle: '数据库：',
            databaseDesc: '数据库节点需要紧跟“大模型”节点，处理查询结果',
            pleaseCreateDatabase: '请先创建数据库',
        },
        EndNode:{
            outputVoice: '输出音色：',
            replyStrategy: '回复策略：',
            replySplit: '分段回复',
            queryMerge: '合并回复',
            delayReply: '延迟回复',
            delayReplyTime: '延迟回复时间',
            replySplitTip: '对于长内容将随机拆分为多段进行回复',
            queryMergeTip: '对于短时间内的多个问题，将进行汇总后一次性回复。该功能需要设置下方 "延迟回复" 时间后才能生效',
            delayReplyTip: '额外延迟一定时间后再进行内容生成和回复',
            second: '秒',
            playFail: '播放失败，请联系管理员',
        },
        FixedReplyNode: {
            fixedReplyTitle: '固定回复：',
        },
        IntentNode: {
            modelTitle: '模型：',
            memoryTip: '记忆：',
            memoryTipDesc: '温度越高回复越具有创意和不确定性，温度越低则回复更严谨',
            memoryTipDesc1: '工作流每轮记忆指每次运行的 开始节点 输入和 结束节点 输出（不包含中间过程内容）',
            memoryTipDesc2: '工作流的记忆内容可能经过了多个与本节点无关的节点加工后得出，请根据实际需求选择是否开启。', 
            pleaseSelectMemoryTurn: '请选择记忆轮次',
            memoryTurn: '轮',
            branch: '分支',
            defaultBranch: '默认分支',
            branchName: '分支名称',
            branchDesc: '请详细描述什么情况下执行该分支',
            addBranch: '添加分支',
        },
        KnowLedgeBaseNode: {
            knowLedgeBaseTitle: '知识库：',
            pleaseCreateKnowledgeBase: '请先创建知识库',
            knowLedgeBaseTip: '知识库节点后面需要接「大模型」节点来处理检索结果，而不需要接「应用」节点',
            searchMode: '检索方式：',
            semanticRetrieval: '语义检索',
            hybridSearch: '增强检索',
            semanticRetrievalTip: '通过语义向量搜索相关文本',
            hybridSearchTip: '通过语义向量叠加全文（关键字）检索混合增强搜索相关文本',  
            similarityThreshold: '相似度阈值：',
            similarityThresholdTip: '只有知识库条目的相似度高于该阈值时才会被检索，可以在 "知识库 - 搜索测试" 中进行测试：',
            similarityThresholdTip1: '高相似度时 (如0.8以上)，只会检索出与问题相关性高的知识，会更准确，同时也容易未命中',
            similarityThresholdTip2: '低相似度时 (如0.7以下)，可能会检索出相关性低的内容，但检索范围更大',
            semanticRetrievalCount: '语义检索条数：',
            semanticRetrievalCountTip: '单次问答从知识库中进行语义检索的最大段落数量，默认为3，条数增加会增大token消耗，注意不要超过模型最大上下文',
            fullTextRetrievalCount: '全文检索条数：',
            fullTextRetrievalCountTip: '单次问答从知识库中进行全文关键词检索的最大段落数量，默认为1，增加会增大token消耗，注意不要超过模型最大上下文',
            fullTextRetrievalCountTip1: '1. 全文检索条数加语义检索条数之和最大为10，优先满足语义检索条数设置',
            fullTextRetrievalCountTip2: '2. 若实际使用时无匹配的关键词，则增强全文检索的实际结果可能为0',
            max: '已最大',
        },
        LlmNode: {
            systemPrompt: '系统提示词：',
            systemPromptTip: '系统提示词非常重要，决定了机器人的人物设定、功能和工作特征，请尽可能用详细的自然语言进行描述，越具体效果越好哦',
            temperatureTitle: '温度：',
            temperatureTip: '温度越高回复越具有创意和不确定性，温度越低则回复更严谨',
            modelTitle: '模型：',
            pleaseSelectModel: '请选择模型',
            generalModel: '通用大模型',
            industryModel: '行业大模型',
            memoryTitle: '记忆：',
            memoryTip: '温度越高回复越具有创意和不确定性，温度越低则回复更严谨',
            memoryTipDesc1: '1.工作流每轮记忆指每次运行的 开始节点 输入和 结束节点 输出（不包含中间过程内容）',
            memoryTipDesc2: '2.工作流的记忆内容可能经过了多个与本节点无关的节点加工后得出，请根据实际需求选择是否开启。',
            pleaseSelectMemoryTurn: '请选择记忆轮次',
            memoryTurn: '轮',
            jsonFormatTitle: '结构化输出：',
            jsonFormatTip: '结构化输出变量',
            outputVariableStructure: '输出变量结构：',
            pleaseInputParameter: '请输入参数',
            pleaseSelectType: '请选择类型',
            string: '字符串',
            number: '数字',
            pleaseInputName: '请输入名称',
            addOutput: '新增变量',
            variableStructureRepeat: '变量结构有重复的code',
        },
        LogicBranchNode: {
            branchTitle: '分支：',
            defaultBranch: '默认分支',
            branch: '分支',
            pleaseInputBranchName: '请输入分支名称',
            branchName: '分支名称',
            branchDesc: '请详细描述什么情况下执行该分支',
            addCondition: '添加条件',
            addBranch: '添加分支',
            and: '且',
            or: '或',
            condition: '条件',
            value: '值',
            Option: {
                contains: '包含',
                not_contains: '不包含',
                eq: '等于',
                neq: '不等于',
                empty: '为空',
                not_empty: '不为空',
                pre_contains: '前缀匹配',
                post_contains: '后缀匹配',
            }
        },
        ManualNode: {
            defaultReply: '默认回复：',
            pleaseInputDefaultReply: '请输入默认回复',
            noticeUser: '通知人：',
            noticeMethod: '通知方式：',
            replyMode: '回复模式：',
            pleaseSelectNoticeUser: '请选择通知人',
            sms: '短信',
            wechatMp: '公众号',
            replyModeTip: '转为人工后，有三种模式可选',
            replyModeTip1: '不回复：转为人工后，需要在"对话管理"模块手动切换为AI回复',
            replyModeTip2: '继续回复：转为人工后AI会继续回复',
            replyModeTip3: '延迟回复：转为人工之后，会在指定的延迟时间后自动切换为AI回复',
            pleaseSelectReplyMode: '请选择回复模式',
            delayReply: '延迟回复：',
            delayReplyTip: '额外延迟一定时间后再进行内容生成和回复',
            delay: '延迟',
            pleaseEnter: '请输入',
            minutes: '分钟后自动转回AI回复',
            strategyReply: {
                noReply: '转人工后不回复',
                continueReply: '转人工后继续回复',
                delayReply: '转人工后延迟回复',
            }
        },
        PluginNode: {
            fillParamEntity: '模型填充',
            structureParameterTitle: '结构化参数：',
            structureParameterTip: '开启后将使用插件中定义的结构化请求和响应',
            requestParameter: '请求参数：',
            requestParameterTip: '插件中定义的请求参数，可填入固定文本或插入变量',
            imageInputTitle: '图片输入：',
            imageInputTip: '开始节点的图片输入',
            fileInputTitle: '文件输入：',
            fileInputTip: '开始节点的文件输入',
            pluginTitle: '插件：',
            pluginTip: '插件返回的结果如需加工成自然语言再往后传递，通常需要在后面接「大模型」节点来处理数据',
            modelTitle: '模型：',
            imageModel: '图像识别模型：',
            imageModelTip: '对图片进行识别和理解，回答用户问题,',
            viewDetails: '详情查看',
            priceDocument: '价格文档',
            responseResultTitle: '响应结果：',
            responseResultTip: '插件返回的响应数据，可被后置节点引用',
            customPlugin: '自定义插件',
            builtinPlugin: '内置插件',  
            array: '数组',
            object: '对象',
            defaultFile: '默认文件',
            defaultText: '默认文本',
            defaultImage: '默认图片',
            fileOutputType: '文件输出类型：',
            fileName: '文件名称：',
            wordDocument: 'Word文档',
            excelTable: 'Excel表格',
            pleaseInputFileName: '输入文件名称',
            fileGenerateResult: '文件生成结果',
        },
        StartNode: {
            inputConfig: '输入配置',
            textInput: '文字输入',
            imageInput: '图片输入',
            fileInput: '文件输入',
            textInputTip: '用户默认的文字提问',
            imageInputTip: '用户上传或发出的图片（可在图像识别插件节点中使用）',
            fileInputTip: '填写应用名称和描述后，由AI帮你一键生成其他内容。注意对于\'应用设定\'这样的关键配置，建议在填写后进行优化，以获得更好的效果。',
            customVariable: '自定义变量',
            addCustomVariable: '新增变量',
            parameterSetting: '参数设置',
            variableType: '变量类型',
            variableName: '变量显示名称',
            pleaseInputVariableName: '请输入变量显示名称',
            versionDescription: '版本说明',
            variable: '变量',
            variableTip: '定义变量的唯一标识，系统将根据标识识别和使用该变量，确认后不可变更',
            variableTip1: '支持英文、数字和下划线"_"',
            isRequired: '是否必填',
            inputPrompt: '输入提示',
            inputPromptTip: '用户进行输入时的文字提示',
            channelRunCondition: '渠道端运行条件',
            channelRunConditionTip1: '工作流接入托管渠道端使用时，如选择“需输入图片和文字”，用户提问需要先发出图片再发出文字才可触发工作流；',
            channelRunConditionTip2: '如选择“可仅输入图片”，则发出图片即可触发工作流',
            needInputImageAndText: '需输入图片和文字',
            onlyInputImage: '可仅输入图片',
            option: '选项',
            optionTip: '请输入选项名称',
            addOption: '新增选项',
            optionDefaultValue: '选项默认值',
            defaultInput: '默认输入',
            pleaseInputDefault: '请输入默认值',
            defaultImage: '默认图片',
            defaultFile: '默认文件',
            text: '文本',
            image: '图片',
            file: '文件',
            defaultText: '默认文字',
            variableRepeat: '变量重复，请检查后调整',
            pleaseAddOption: '请新增选项',
            optionEmpty: '选项不能为空',
            pleaseSelectDefault: '请选择默认值',
            deleteVariableTip: '删除变量可能会导致引用该变量的节点工作异常，建议检查无误后再删除!',
            deleteVariable: '删除变量',
            fileSizeLessThan15MB: '文件大小需小于 15MB!',
            versionFeatures: '功能，',
            seeDetails: '详见',
            singleChoice: '单选',
            systemVariable: '系统变量',
        },
        TiemNode: {
            cronRule: '定时规则：',
            createRule: '创建规则',
            cronSetting: '定时设置',
            nodeInputTitle: '节点输入：',
            nodeInputContent: '工作流定时执行的开始节点输入内容',
            smartGeneration: '智能生成',
            cronExpression: 'cron表达式',
            howToWrite: '如何撰写',
            howToWriteCronExpression: 'cron定时规则表达式？',
            describeCronRule: '用自然语言描述定时任务的时间规则',
            generateCron: '一键生成',
            exampleOne: '示例一：',
            exampleTwo: '示例二：',
            exampleOneContent: '每天早上8点执行一次',
            exampleTwoContent: '周一到周五早上9点和晚上18点各执行一次',
            pleaseInputCronExpression: '请输入5位字符cron表达式',
            preview: '一键预览',
            cronPreview: '定时预览：',
            cronExpressionTitle: 'cron表达式：',
            pleaseInputYourCronExpression: '请输入您的cron表达式',
            last10ExecutionTime: '近10次执行时间：',
            nodeInputCannotBeEmpty: '节点输入不能为空',
            cronExpressionCannotBeEmpty: 'cron表达式不能为空',
            saveSuccess: '保存成功',
            confirmClearCronRule: '是否确认清空定时规则?',
            clearCronRule: '清空定时规则',
            confirmDeleteCronTask: '是否确认删除该定时任务?',
            deleteCronTask: '删除定时任务',
            deleteSuccess: '删除成功',
        },
        checkNode: {
            pleaseSelectModel: '请选择模型',
            pleaseInputBranchName: '请输入分支名称',
            noConnectBranch: '存在未连接的分支',
            pleaseAddBranchCondition: '请添加分支条件',
            pleaseSetBranchCondition: '请设置分支条件',
            pleaseSelectKnowledgeBase: '请选择知识库',
            pleaseSelectApp: '请选择应用',
            pleaseSelectPlugin: '请选择插件',
            pleaseInputDefaultReply: '请输入默认回复',
            pleaseSelectDatabase: '请选择数据库',
            pleaseSelectClient: '请选择客户端',
            pleaseSelectSender: '请选择发送人',
            pleaseSelectSendType: '请选择发送类型',
            pleaseSelectReceiver: '请选择接收者',
            pleaseFillWebhookUrl: '请填写webhook_url',
            pleaseFillWebhookSecret: '请填写webhook_secret',
            alreadyContainsStartNode: '已经含有一个开始节点',
            alreadyContainsEndNode: "已经含有一个结束节点"
        },
        nodeConfig: {
            start: '开始',
            end: '结束',
            app: '应用',
            appDesc: '使用已创建的轻量应用或知识应用生成内容',
            llm: '大模型',
            llmDesc: '调用大语言模型，并结合系统提示词生成回复',
            knowledgeBase: '知识库',
            knowledgeBaseDesc: '选取特定知识库，根据输入内容检索知识库并输出',
            database: '数据库',
            databaseDesc: '对数据库进行读写操作',
            plugin: '插件',
            pluginDesc: '使用内置插件或自定义插件执行任务',
            code: '代码',
            codeDesc: '编写Python或JavaScript代码处理入参并输出结果',
            intentBranch: '意图分支',
            intentBranchDesc: '通过意图识别，根据输入内容判断后续流程分支',
            logicBranch: '逻辑分支',
            logicBranchDesc: '根据输入变量的值进行逻辑判断，选择后续流程分支',
            fixedReply: '固定回复',
            fixedReplyDesc: '输出设置的固定内容',
            channelSend: '渠道发送',
            channelSendDesc: '将内容发送至所选取的接入渠道',
            manual: '转人工',
            manualDesc: '直接执行对话“转人工”并发送提醒',
        },
        nodeDefault: {
            intentBranch: '意图分支',
            defaultBranch: '默认分支',
            defaultBranchDesc: '其它意图未命中时默认选择该分支',
            start: '开始',
            defaultText: '默认文本',
            defaultImage: '默认图片',
            defaultFile: '默认文件',
            end: '结束',
            fixedReply: '固定回复',
            llm: '大模型',
            app: '应用',
            channelSend: '渠道发送',
            knowledgeBase: '知识库',
            database: '数据库',
            plugin: '插件',
            code: '代码',
            logicBranch: '逻辑分支',
            defaultLogicBranch: '默认分支',
            codeBlock: '代码块',
            manual: '转人工',
            defaultOutput: '默认输出',
            codeLogic: '以下为代码逻辑，注意缩进',
        },
        detail: '详情',
        runSuccess: '运行成功',
        runFailed: '运行失败',
        returnList: '返回列表',
        startRun: '开始运行',
        saveSuccess: '保存成功',
        knowledgeBase: '知识库：',
        knowledgeHitCount: '知识库命中条数：',
        contextCount: '上下文数量：',
        question: '问题：',
        answer: '答案：',   
        sqlStatement: 'SQL语句：',
        executionStatus: '执行状态：',
        output: '输出：',
        branchSelection: '分支选择：',
        executionSuccess: '执行成功',
        executionFailed: '执行失败',
        noExecution: '无需执行',
        inputTip: '输入：',
        nodeRun: '节点运行：',
        singleNodeRunInput: '单节点运行输入',
        fullFlowRunInput: '全流程运行输入',
        pleaseSelect: '请选择',
        image: '图片',
        ChatContextClearedSuccessfully: '清除对话上下文成功',
        imageUploadFailed: '图片上传失败',
        fileSizeLessThan15MB: '文件大小需小于 15MB!',
        pleaseConnectEndNode: '请连接结束节点',
        variableDoesNotExist: '变量不存在，请更换变量',
        nodeContentC: '节点中',
        saveFailed: '保存失败',
        pleaseEnterTheFlowName: '请输入工作流名称',
        pleaseEnterTheFlowDescription: '请输入工作流描述',
        pleaseUploadImage: '请上传图片',
        pleaseSelectGroup: '请选择分组',
        modifySuccess: '修改成功',
        official: 'LinkAi',
        imageUploadOnlySupportJpegPngFormat: '图片上传只支持 jpeg,png 格式',
        publishSuccess: '发布成功!',
        goToDialog: '前往对话',
        cancelPublish: '是否确认取消该工作流发布到广场?',
        cancelPublishConfirm: '取消发布',
        closeSuccess: '关闭成功',
        closeFailed: '关闭失败，请重试',
        clock: '定时',
        runTo: '运行',
        running: '运行中',
        save: '保存',
        saveLoading: '保存中',
        publish: '发布',
        publishSquare: '发布广场',
        displayOnAppSquare: '开启后工作流最新保存并点击发布的版本可在广场中被发现和使用',
        channelAccess: '接入渠道',
        apiCall: 'API调用',
        access: '接入',
        officialWebsite: '官网',
        document: '文档',
        editFlow: '编辑工作流',
        cancel: '取消',
        confirm: '确认'
    }
}